import ReactModal from 'react-modal';
import { useTranslation } from 'react-i18next';

import Button from '../library/Button/Button';
import { domains } from 'global';
import styles from './NotOwnerModal.module.css';

export default function NotOwnerModal() {
  const { t } = useTranslation();

  return (
    <ReactModal
      isOpen
      className={styles.modal}
      overlayClassName={styles.modalOverlay}
      ariaHideApp={false}
    >
      <div className={styles.bodyModal}>
        <div>
          <h1 className={styles.icon}><span className={`${styles.materialIcons} material-icons`}>cancel</span></h1>
        </div>
        <h3>{t('modal.notOwnerTitle')}</h3>
        <p className={`${styles.text}`}>{t('modal.notOwnerDescription')}</p>
        <Button
          className={styles.button}
          variant="fill"
          type="secondary"
          label={t('modal.notOwnerButton')}
          onButtonClick={() => window.open(domains.website)}
        />
      </div>
    </ReactModal>
  );
}
